import { ICON_TYPES } from './iconTypes';

export default {
	hospital: {
		name: 'hospital',
		type: ICON_TYPES.fontAwesome5,
		text: 'Hospital',
	},
	doctor: {
		name: 'doctor',
		type: ICON_TYPES.fontisto,
		text: 'Doctor',
	},
	case: {
		name: 'file-medical',
		type: ICON_TYPES.fontAwesome5,
		text: 'New',
	},
	analyze: {
		name: 'cogs',
		type: ICON_TYPES.fontAwesome5,
		text: 'Analyze',
	},
};